<template>
    <div>
        <content-view>
            <!-- 批量报价 -->
            <div slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="物料编码">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['goodsNo']"></a-input>
                    </a-form-item>
                    <a-form-item label="物料条形码">
                        <a-input placeholder="请输入" v-decorator="['goodsBarCode']"></a-input>
                    </a-form-item>
                    <a-form-item label="物料名称">
                        <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                    </a-form-item>
                    <a-form-item label="物料分组">
                        <a-input placeholder="请输入" v-decorator="['goodsGroup']"></a-input>
                    </a-form-item>
                    <a-form-item label="物料属性">
                        <a-input placeholder="请输入" v-decorator="['goodsType']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="search" :loading="tableLoading">筛选</a-button>
                        <a-button @click="handleReset()" :loading="tableLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <div class="mb24 flex flex-space-between">
                    <span class="text-fail">本页仅展示50条需报价数据，提交后将刷新展示新50条需报价数据</span>
                </div>
                <a-table
                bordered
                :dataSource="goodsData"
                :columns="columns"
                :pagination="false"
                :rowKey="record => record.id"
                :loading="tableLoading"
                class="wrap-table"
                >
                    <template slot="empty" slot-scope="key, row, index">
                        {{key || "-"}}
                    </template>
                    <template slot="setBasePrice" slot-scope="key, row, index">
                        <template v-if="Boolean(shopId == -1) && row.basePrice === null">
                            <a-input-number @change="baseChange($event, row)" placeholder="请输入" v-model="row.newBasePrice" />
                            <div v-if="row.showBaseError" class="text-fail">所填值不能小于0，且只保留两位小数</div>
                        </template>
                        <template v-else>
                            {{key}}
                        </template>
                    </template>
                    <template slot="setPrice" slot-scope="key, row, index">
                        <a-input-number @change="change($event, row)" placeholder="请输入" v-model="row.newPrice" />
                        <div v-if="row.showError" class="text-fail">所填值不能小于0，且只保留两位小数</div>
                    </template>
                </a-table>
                <div class="text-center mt16">
                    <a-button type="primary" @click="goodsRemindUpdate" :loading="remindUpdateLoading">提交</a-button>
                </div>
            </div>
        </content-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: '物料编码',
            dataIndex: 'goodsNo',
        },
        {
            title: '物料条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }

        },
        {
            title: '物料名称',
            dataIndex: 'goodsName'
        },
        {
            title: '规格型号',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '数据状态',
            dataIndex: 'documentStatusStr'
        },
        {
            title: '物料分组',
            dataIndex: 'goodsGroup'
        },
        {
            title: '物料属性',
            dataIndex: 'goodsType'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '默认售卖价',
            dataIndex: 'basePrice',
            scopedSlots: { customRender: 'setBasePrice' }
        },
        {
            title: '实际售卖价',
            dataIndex: 'price',
            scopedSlots: { customRender: 'setPrice' }
        },
    ];
    export default {
        name: 'materielRemind',
        components: {},
        props: {},
        data() {
            return {
                columns,
                tableLoading: false,
                goodsData: [],
                remindUpdateLoading: false
            };
        },
        watch: {
            'shopId'() {
                this.getGoodsList();
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @baseChange 默认售卖价输入回调
             */
            baseChange(val, record) {
                if (val === '') {
                    record.newBasePrice = undefined;
                    record.showBaseError = false;
                    return
                }
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/;
                record.showBaseError = !regExp.test(val);
            },
            /**
             * @change 实际售卖价输入回调
             */
            change(val, record) {
                if (val === '') {
                    record.newPrice = undefined;
                    record.showError = false;
                    return
                }
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/;
                record.showError = !regExp.test(val);
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getGoodsList();
            },
            search() {
                this.getGoodsList();
            },
            /**
             * @getGoodsList 获取为报价商品
             */
            getGoodsList() {
                if (!this.shopId || this.tableLoading) {
                    return false;
                }
                this.filterForm.validateFields((errors, values) => {
                    if (errors) return;
                    this.tableLoading = true;
                    this.$api.newStorage.kingDiskOfferPage({
                        body: {
                            ...values,
                            pageNum: 1,
                            pageSize: 50,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        this.tableLoading = false;
                        res.data.forEach(item => {
                            item.newBasePrice = undefined;
                            item.newPrice = undefined;
                            item.showBaseError = false;
                            item.showError = false;
                        });
                        this.goodsData = res.data;
                    }).catch(err => {
                        this.tableLoading = false;
                    });
                });
            },
            /**
             * @goodsRemindUpdate 批量修改物料报价
             */
            goodsRemindUpdate() {
                let infoList = this.goodsData.map(item => {
                    return {
                        goodsNo: item.goodsNo,
                        price: item.newBasePrice === null ? undefined : item.newBasePrice,
                        realPrice: item.newPrice === null ? undefined : item.newPrice
                    }
                }).filter(item => {
                    if (Number(this.shopId) === -1) {
                        return !(typeof item.price === 'undefined' && typeof item.realPrice === 'undefined');
                    } else {
                        return !(typeof item.realPrice === 'undefined');
                    }
                });
                let emptyItem = infoList.find(item => {
                    const regExp = /^([0-9]{1,}\d*[.]*\d{0,2})$|^([0]{1}[.]{1}\d{1,2})$/;
                    if (Number(this.shopId) === -1) {
                        return ((typeof item.price !== 'undefined' && !regExp.test(item.price)) || (typeof item.realPrice !== 'undefined' && !regExp.test(item.realPrice)));
                    } else {
                        return (typeof item.realPrice !== 'undefined' && !regExp.test(item.realPrice));
                    }
                });
                if (infoList.length === 0 || Boolean(emptyItem)) {
                    this.$message.error('请输入正确的价格');
                    return false;
                }
                this.remindUpdateLoading = true;
                this.$api.newStorage.kingDiskRemindUpdate({
                    body: {
                        infoList,
                        shopId: this.shopId,
                        userId: this.userInfo.id,
                        account: this.userInfo.account,
                        username: this.userInfo.name
                    }
                }).then(res => {
                    this.$message.success('操作成功！');
                    this.remindUpdateLoading = false;
                    setTimeout(() => {
                        this.getGoodsList();
                    }, 300);
                }).catch(err => {
                    this.remindUpdateLoading = false;
                });
            }
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.getGoodsList();
        },
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
</style>
